<template>
    <div class="container">
        <md-dialog :md-active.sync="showDialogEdit" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.editCompany }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.name}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <md-field>
                            <md-input type="text" name="name" v-model="Item.nombre" :placeholder="labels.name" />
                        </md-field>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.moneda}}</h5>
                    </b-col>
                    <b-col cols="6" lg="6" class="text-left">
                        <select v-model="Item.id_moneda" id="idCurrency" class="form-control">
                            <option v-for="currency in listCurrency" :key="currency.id" :value="currency.id"> {{
                                currency.nombre }} </option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.acronym}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <md-field>
                            <md-input type="text" name="name" v-model="Item.acronym" :placeholder="labels.acronym" />
                        </md-field>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.code}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <md-field>
                            <md-input type="text" name="name" v-model="Item.codigo" :placeholder="labels.codigo" />
                        </md-field>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.codReporte}}</h5>
                    </b-col>
                    <b-col cols="6" lg="6" class="text-left">
                        <select v-model="Item.codReporte" id="codReporte" class="form-control">
                            <option v-for="reportes in listReportes" :key="reportes.id" :value="reportes.codigo"> {{
                                reportes.nombre }} </option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{ labels.nit }}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <md-field>
                            <md-input type="text" name="nit" v-model="Item.identificacion" :placeholder="labels.nit" />
                        </md-field>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{ labels.group }}</h5>
                    </b-col>
                    <b-col cols="6" lg="6" class="text-left">
                        <!-- Siempre mostrar el select para permitir cambios -->
                        <select v-model="selectedGrupos" multiple id="id_grupos" class="form-control" size="4">
                            <option value="">Sin grupo</option>
                            <option v-for="grupo in listGrupos" :key="grupo.id" :value="grupo.id">
                                {{ grupo.nombre }}
                            </option>
                        </select>
                    </b-col>
                </b-row>

                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="editCompany">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="clicked">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
    import Company from "@/services/Company"
    import Currency from "@/services/Currency"
    import Balance from "@/services/BalanceNiif"
    import Grupo from "@/services/Grupo"

    export default {
        name : "Edit",
        props: ['showDialogEdit','Item'],

        data: () => ({
            form : {
                name : "",
                id_moneda : "",
                acronym : "",
                code : "",
                codReporte : ""
            },
            listCurrency : "",
            listReportes : "",
            listGrupos : "",
            idCurrency : "",
            selectedGrupos: []
        }),

        computed: {
            labels(){
                if (this.$store.state._language == "es-ES") {
                    return {
                        editCompany : "Editar compañía",
                        name : "Nombre",
                        moneda : "Moneda",
                        acronym : "Acrónimo",
                        code : "Código",
                        nit: "NIT",
                        codReporte : "Reporte",
                        group: "Grupo",
                        save : "Guardar",
                        close : "Cerrar"
                    }
                }else{
                    return {
                        editCompany : "Edit company",
                        name : "Name",
                        moneda : "Currency",
                        acronym : "Acronym",
                        code : "Code",
                        nit: "NIT",
                        codReporte : "Report",
                        group: "Group",
                        save : "Save",
                        close : "Close"
                    }
                }
            }
        },
        
        methods : {
            editCompany(){
                this.Item.id_grupos = this.selectedGrupos.join(',');
                
                Company.updateCompany(this.Item)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.$emit('companyUpdated', true);
                    this.clicked();
                }).catch((error) => {
                    console.log(error)
                })
            },
            clicked(){
                this.$emit('clicked', false);
            }
        },
        
        mounted () {
            Currency.getAllCurrency()
            .then((res) => {
                this.listCurrency = res.data.currency;
            }).catch((error) => {
                console.log(error)
            })
            
            Balance.getReportes()
            .then ((result) => {
                this.listReportes = result.data.reportes;
            }).catch((error) => console.log(error));
            
            Grupo.getAllGrupos()
            .then((res) => {
                this.listGrupos = res.data.grupos;
                if (this.Item.id_grupos) {
                    this.selectedGrupos = this.Item.id_grupos
                        .split(',')
                        .map(id => parseInt(id.trim()))
                        .filter(id => !isNaN(id));
                }
            }).catch((error) => console.log(error));
        }
    }
</script>

<style scoped>
.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-left {
    text-align: left;
    display: flex;
    align-items: center;
}

h5 {
    margin-bottom: 0;
}
</style>